/**
 * Sample professional profiles for layout preview — 20 fully-populated
 * placeholder entries (local SVG avatars under /PlaceholderImgs/avatars/).
 *
 * Rendered on the professionals index behind the admin Visibility tab's
 * "Professionals placeholders" toggle: the "Render placeholders" button
 * merges these into the directory so search and every filter (language /
 * location / expertise) can be exercised with realistic variety, and the
 * detail page resolves their slugs so the cards click through.
 *
 * All slugs carry the `sample-` prefix so they can never collide with real
 * published profiles (real data always wins on conflict anyway).
 */
import placeholderJson from "@/data/professionalPlaceholders.json";
import { assetUrl } from "@/utils/asset";
import type { ProfessionalData } from "@/types/professionals";

export const placeholderProfessionals: ProfessionalData[] =
    placeholderJson as ProfessionalData[];

/** Placeholder with `photoUrl` resolved through assetUrl (base-path safe). */
const withResolvedPhoto = (p: ProfessionalData): ProfessionalData => ({
    ...p,
    photoUrl: p.photoUrl ? assetUrl(p.photoUrl) : undefined,
});

export const getPlaceholderProfessionals = (): ProfessionalData[] =>
    placeholderProfessionals.map(withResolvedPhoto);

/** Look up one placeholder by slug (or id); undefined when no match. */
export const findPlaceholderProfessional = (
    slugOrId: string,
): ProfessionalData | undefined => {
    const key = String(slugOrId || "").trim();
    if (!key) return undefined;
    const hit = placeholderProfessionals.find(
        (p) => p.slug === key || p.id === key,
    );
    return hit ? withResolvedPhoto(hit) : undefined;
};
